import { registerCapability } from '../../platform/capability-registry';
import { StartupCommandArgsBlock } from './StartupCommandArgsBlock';
import { STARTUP_COMMAND_ARGS_ACTION_KEY_LIST, STARTUP_COMMAND_ARGS_FIELD_KEY_LIST } from './fieldKeys';
import { resolveStartupCommandArgsPaths } from './resolvePaths';
import type { StartupCommandArgsBlockOptions } from './types';

registerCapability<StartupCommandArgsBlockOptions>({
  key: 'startup-command-args',
  fields: [...STARTUP_COMMAND_ARGS_FIELD_KEY_LIST],
  actions: [...STARTUP_COMMAND_ARGS_ACTION_KEY_LIST],
  component: StartupCommandArgsBlock,
  defaultPaths: (prefix) => resolveStartupCommandArgsPaths(prefix),
  resolvePaths: (prefix, options) => resolveStartupCommandArgsPaths(prefix, options),
});
